export default "https://cdn-static.gokick.com/assets/d7539373fb86e46f3eed15b4b495ca9c5158faa3/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";